import React, { FC, createContext, use, PropsWithChildren } from 'react';
import { TopicTracked, ServiceTracked, ActionTrackedInfo } from 'models/tracking';

interface ServiceTrackingContextProps {
    serviceTracked: ServiceTracked;
}

export const ServiceTrackingContext = createContext<ServiceTrackingContextProps>({
    serviceTracked: {
        topic: TopicTracked.None,
        service: undefined,
        origin: undefined,
    },
});

export const useServiceTrackingContext = () => use(ServiceTrackingContext);

export const ServiceTrackingInfoProvider: FC<PropsWithChildren<ServiceTrackingContextProps>> = ({ serviceTracked, children }) => {
    return (
        <ServiceTrackingContext
            value={{
                serviceTracked,
            }}
        >
            {children}
        </ServiceTrackingContext>
    );
};

interface ActionTrackingContextProps {
    actionTrackedInfo: ActionTrackedInfo,
}

export const ActionTrackingContext = createContext<ActionTrackingContextProps>(
    {
        actionTrackedInfo: {
            topic: TopicTracked.None,
        },
    });

export const useActionTrackingContext = () => use(ActionTrackingContext);

export const ActionTrackingInfoProvider: FC<PropsWithChildren<ActionTrackingContextProps>> = ({ actionTrackedInfo, children }) => {
    return (
        <ActionTrackingContext
            value={{
                actionTrackedInfo,
            }}
        >
            {children}
        </ActionTrackingContext>
    );
};
